/* eslint-disable */
import React, { Component } from "react";
import { Link } from "react-router-dom";
import DashboardHeader from "../includes/dashboardHeader/DashboardHeader";
import DashboardSidebar from "../includes/dashboardSidebar/DashboardSidebar";
import FooterComponent from "../includes/dashboardFooter/FooterComponent";
import axios from "axios";
import config from "../../config";
import "./ReportingDashboard.css";

class ReportingComputation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            parameters: [],
            allOperatingUnits: [],
            unitOptions: ["All Operating Units"],
            selectedUnit: "All Operating Units",
            selectedParameter: "",
            financialYear: "FY 2024-2025",
            fromMonth: "",
            toMonth: "",
            loading: false,
            computing: false,
            result: null,
            error: "",
        };
    }

    componentDidMount() {
        this.fetchParameters();
    }

    /** ───────────────────────────────
     *  FETCH PARAMETERS
     *  ─────────────────────────────── */
    fetchParameters = async () => {
        try {
            const cardId = this.props.match?.params?.id || 1;
            this.setState({ loading: true, error: "" });

            const response = await axios.get(
                `${config.laravelBaseUrl}reporting-dashboard/parameter-units`,
                {
                    params: { card_id: cardId },
                    headers: {
                        Authorization: "Bearer " + sessionStorage.getItem("userToken"),
                    },
                }
            );

            if (response.data?.success) {
                const { parameters = [], operating_units = [] } = response.data.data;

                // ✅ Build clean global unit list
                const unitNames = operating_units
                    .filter(u => u && u.name) // ignore null or missing names
                    .map(u => u.name);

                this.setState({
                    parameters,
                    allOperatingUnits: operating_units,
                    unitOptions: ["All Operating Units", ...unitNames],
                    loading: false,
                });
            } else {
                this.setState({
                    error: response.data?.message || "Failed to fetch parameters.",
                    loading: false,
                });
            }
        } catch (err) {
            console.error("Error fetching parameters:", err);
            this.setState({
                error: "Failed to fetch parameters.",
                loading: false,
            });
        }
    };


    /** ───────────────────────────────
     *  TRIGGER COMPUTATION (Backend auto-handles logic)
     *  ─────────────────────────────── */
    handleCompute = async () => {
        const { selectedParameter, financialYear, fromMonth, toMonth, selectedUnit } = this.state;

        if (!selectedParameter || !financialYear || !fromMonth || !toMonth) {
            alert("Please select all required fields before computation.");
            return;
        }

        try {
            this.setState({ computing: true, result: null, error: "" });

            const response = await axios.post(
                `${config.laravelBaseUrl}reporting-dashboard/compute`,
                {
                    card_id: this.props.match?.params?.id || 1,
                    parameter_id: selectedParameter,
                    financial_year: financialYear,
                    from_month: fromMonth,
                    to_month: toMonth,
                    operating_unit: selectedUnit === "All" ? null : selectedUnit,
                },
                {
                    headers: {
                        Authorization: "Bearer " + sessionStorage.getItem("userToken"),
                    },
                }
            );

            if (response.data?.success) {
                this.setState({ result: response.data.data, computing: false });
            } else {
                this.setState({
                    computing: false,
                    error: response.data?.message || "Computation failed.",
                });
            }
        } catch (err) {
            console.error("Computation error:", err);
            this.setState({
                computing: false,
                error: "Computation failed.",
            });
        }
    };

    /** ───────────────────────────────
     *  RENDER PARAMETER & FILTERS
     *  ─────────────────────────────── */
    renderComputationFilters = () => {
        const { parameters, selectedParameter } = this.state;

        return (
            <div className="card mb-4 shadow-sm rounded-lg border-0">
                <div className="card-header bg-white border-0 pb-1">
                    <h6 className="font-weight-bold text-primary mb-1">
                        Computation Setup
                    </h6>
                    <p className="text-muted small mb-0">
                        Select a parameter for computation.
                    </p>
                </div>

                <div className="card-body">
                    <div className="row">
                        <div className="col-md-4 mb-3">
                            <label className="font-weight-bold small">Parameter</label>
                            <select
                                className="form-control form-control-sm"
                                value={selectedParameter}
                                onChange={(e) =>
                                    this.setState({ selectedParameter: e.target.value })
                                }
                            >
                                <option value="">Select Parameter</option>
                                {parameters.map((p) => (
                                    <option key={p.id} value={p.id}>
                                        {p.data_name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        {/* Operating Unit */}
                        <div className="col-md-4 mb-3">
                            <label className="font-weight-bold small">Operating Unit</label>
                            <select
                                className="form-control form-control-sm"
                                value={this.state.selectedUnit}
                                onChange={(e) => this.setState({ selectedUnit: e.target.value })}
                            >
                                {this.state.unitOptions.map((unit, i) => (
                                    <option key={i} value={unit}>
                                        {unit}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    /** ───────────────────────────────
     *  RENDER TIME PERIOD FILTER
     *  ─────────────────────────────── */
    renderTimePeriodSelection = () => {
        const { financialYear, fromMonth, toMonth } = this.state;
        const months = [
            "April", "May", "June", "July", "August", "September",
            "October", "November", "December", "January", "February", "March",
        ];

        return (
            <div className="card mb-4 shadow-sm rounded-lg border-0">
                <div className="card-header bg-white border-0 pb-1">
                    <h6 className="font-weight-bold text-primary mb-1">
                        Time Period Selection
                    </h6>
                    <p className="text-muted small mb-0">
                        Choose financial year and month range for computation.
                    </p>
                </div>

                <div className="card-body">
                    <div className="row">
                        {/* Financial Year */}
                        <div className="col-md-4 mb-3">
                            <label className="font-weight-bold small">Financial Year</label>
                            <select
                                className="form-control form-control-sm"
                                value={financialYear}
                                onChange={(e) =>
                                    this.setState({ financialYear: e.target.value })
                                }
                            >
                                <option>FY 2024-2025</option>
                                <option>FY 2025-2026</option>
                            </select>
                        </div>

                        {/* From Month */}
                        <div className="col-md-4 mb-3">
                            <label className="font-weight-bold small">From Month</label>
                            <select
                                className="form-control form-control-sm"
                                value={fromMonth}
                                onChange={(e) =>
                                    this.setState({ fromMonth: e.target.value })
                                }
                            >
                                <option value="">Select</option>
                                {months.map((m) => (
                                    <option key={m} value={m}>
                                        {m}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* To Month */}
                        <div className="col-md-4 mb-3">
                            <label className="font-weight-bold small">To Month</label>
                            <select
                                className="form-control form-control-sm"
                                value={toMonth}
                                onChange={(e) =>
                                    this.setState({ toMonth: e.target.value })
                                }
                            >
                                <option value="">Select</option>
                                {months.map((m) => (
                                    <option key={m} value={m}>
                                        {m}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    /** ───────────────────────────────
     *  RENDER COMPUTATION RESULT
     *  ─────────────────────────────── */
    renderComputationResult = () => {
        const { result } = this.state;
        if (!result) return null;

        return (
            <div className="card shadow-sm border-0 rounded-lg mt-4">
                <div className="card-header bg-white border-0 pb-1">
                    <h6 className="font-weight-bold text-success mb-1">
                        Computation Results — {result.parameter}
                    </h6>
                    <p className="text-muted small mb-0">
                        Table: {result.table} | Units:{" "}
                        {result.filters.operating_units?.join(", ") || "All"}
                    </p>
                </div>

                <div className="card-body">
                    {result.data?.length ? (
                        <table className="table table-bordered table-sm">
                            <thead className="thead-light">
                                <tr>
                                    <th>Category</th>
                                    <th>Value ({result.data[0].unit})</th>
                                </tr>
                            </thead>
                            <tbody>
                                {result.data.map((row, idx) => (
                                    <tr key={idx}>
                                        <td>{row.category}</td>
                                        <td>{Number(row.value).toLocaleString()}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        <p className="text-muted text-center mb-0">
                            No data available for the selected filters.
                        </p>
                    )}
                </div>
            </div>
        );
    };

    render() {
        const { loading, error, computing } = this.state;

        return (
            <>
                <DashboardHeader />
                <div id="wrapper">
                    <DashboardSidebar />
                    <div id="content-wrapper" className="d-flex flex-column">
                        <div id="content">
                            <ol className="breadcrumb dashbread">
                                <li className="breadcrumb-item">
                                    <Link to="/dashboard">Home</Link>
                                </li>
                                <li className="breadcrumb-item">
                                    <Link to="/reporting/dashboard">Reporting</Link>
                                </li>
                                <li className="breadcrumb-item active">Computation</li>
                            </ol>

                            <div className="container-fluid container-dashboard">
                                <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
                                    <h5 className="heading text-dark font-weight-bold mb-2">Computation</h5>

                                    <Link
                                        to="/reporting/dashboard"
                                        className="btn btn-sm text-white shadow-sm mb-2"
                                        style={{
                                            background: "#1232c3",
                                            borderRadius: "4px",
                                            fontWeight: 500,
                                            marginTop: '1rem'
                                        }}
                                    >
                                        <i className="fas fa-arrow-left mr-1"></i> Back to Dashboard
                                    </Link>
                                </div>

                                {loading ? (
                                    <div className="text-center mt-5">
                                        <div className="spinner-border text-primary" role="status"></div>
                                        <p className="mt-2 text-muted">Loading parameters...</p>
                                    </div>
                                ) : error ? (
                                    <div className="alert alert-danger text-center shadow-sm">{error}</div>
                                ) : (
                                    <>
                                        {this.renderComputationFilters()}
                                        {this.renderTimePeriodSelection()}

                                        <div className="text-right mt-3">
                                            <button
                                                className="btn btn-primary shadow-sm"
                                                onClick={this.handleCompute}
                                                disabled={computing}
                                            >
                                                {computing ? (
                                                    <>
                                                        <i className="fas fa-spinner fa-spin mr-1"></i> Computing...
                                                    </>
                                                ) : (
                                                    <>
                                                        <i className="fas fa-calculator mr-1"></i> Compute
                                                    </>
                                                )}
                                            </button>
                                        </div>

                                        {this.renderComputationResult()}
                                    </>
                                )}
                            </div>

                        </div>
                        <FooterComponent />
                    </div>
                </div>
            </>
        );
    }
}

export default ReportingComputation;
